import './Subscription.scss'
import {useEffect, useRef, useState} from "react";
import { useAuth } from '../../../auth/AuthProvider';
import { createCustomer, getCustomer, getActiveSubscriptions } from '../../../services/subscription.service.tsx';
import { Button } from '@fluentui/react-components';

const environment = process.env.REACT_APP_ENV

function Subscription()
{
    const {isAuthenticated, user} = useAuth();
    const premiumSubcriptionLink = `https://buy.stripe.com/test_9B6dR25oFfDK1LrgPq5AQ00?locked_prefilled_email=${user}`;
    const goldSubcriptionLink = `https://buy.stripe.com/test_14A28kdVbdvC3Tzbv65AQ01?locked_prefilled_email=${user}`;
    const basicSubcriptionLink = `https://buy.stripe.com/test_28E3coeZf8bibm1dDe5AQ02?locked_prefilled_email=${user}`;

    const[userCustomer, setCustomer] = useState(null);

    async function getCustomerInfo()
    {
        let response = await getCustomer(user);        
        setCustomer(JSON.stringify(response.data));
    }

    async function setUserCustomer()
    {
        let response = await createCustomer(user);
        console.log("Create customer response: ",JSON.stringify(response));
    }

    async function getSubscriptions()
    {
        let response = await getActiveSubscriptions(user);
        setCustomer(JSON.stringify(response));
        console.log("list of subcriptions", JSON.stringify(response));
    }

    return(
        <div>
            <Button onClick={getCustomerInfo}>get user info</Button>
            <h3>Please select subcription for account:{user}</h3>
            <Button onClick={setUserCustomer}>create user</Button>
            <hr/>
            <Button onClick={getSubscriptions}>List of subscritiption</Button>
            <p>{userCustomer}</p>
            {(environment==='dev') &&
            <div className='d-flex justify-content-between flex-wrap'>
                <div>
                    <a href={premiumSubcriptionLink}><Button shape='circular'>Premium Subscription</Button></a>
                </div>
                <div>
                    <a href={goldSubcriptionLink}><Button shape='circular'>Gold Subscription</Button></a>
                </div>
                <div>
                    <a href={basicSubcriptionLink}><Button shape='circular'>Basic Subscription</Button></a>
                </div>
            </div>
            }                      
            {(environment==='dev') && <stripe-pricing-table pricing-table-id="prctbl_1RxKjs2e1reVaqG0KbWL6Hr0"
            publishable-key="pk_test_51RuhG92e1reVaqG0S4E0azYw1gH2ieT1jhL1tYD7nKpLOtnecSSe1C2iig8D4pKaFmfm91JvAxtLcNbo4U4yt9ri00hjF6dYLW">
            </stripe-pricing-table>}            
        </div>
    );
}

export default Subscription;